import { Button, HStack, Spacer } from "@chakra-ui/react";
import { useField, FieldAttributes } from "formik";
import { Label } from "./Label";
// import { ErrorMessage } from "./ErrorMessage";

export const OkNotOkButtons = ({
  label,
  type,
  ...props
}: FieldAttributes<any>) => {
  const [field, , helpers] = useField(props);
  return (
    <HStack>
      <Label>{label}</Label>
      <Spacer />
      <HStack spacing={4}>
        <Button
          data-cy={`${field.name}_ok`}
          minWidth={90}
          textTransform="uppercase"
          onClick={() => {
            helpers.setValue(true);
          }}
          size="sm"
          variant="outline"
          colorScheme={field.value === true ? "blue" : "gray"}
          {...(field.value === true ? { backgroundColor: "blue.50" } : {})}
        >
          Ok
        </Button>
        <Button
          data-cy={`${field.name}_not_ok`}
          minWidth={90}
          textTransform="uppercase"
          onClick={() => {
            helpers.setValue(false);
          }}
          size="sm"
          variant="outline"
          colorScheme={field.value === false ? "blue" : "gray"}
          {...(field.value === false ? { backgroundColor: "blue.50" } : {})}
        >
          Not Ok
        </Button>
      </HStack>

      {/* {meta.touched && meta.error ? (
        <ErrorMessage>{meta.error}</ErrorMessage>
      ) : null} */}
    </HStack>
  );
};
